import { render, staticRenderFns } from "./PolicyGroups.vue?vue&type=template&id=667e7792&"
import script from "./PolicyGroups.vue?vue&type=script&lang=js&"
export * from "./PolicyGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports